module.exports = __webpack_public_path__ + "img/failed.1321990f.png";